<template>
  <v-app>
    <DialogHelpCenter />
    <v-container class="pa-0 fill-height">
      <v-row v-if="isLoading">
        <v-col class="col-12">
          <div class="d-flex justify-center align-center flex-column">
            <p>Carregando...</p>
            <v-progress-circular
              indeterminate
              color="primary"
              class="mb-0"
            ></v-progress-circular>
          </div>
        </v-col>
      </v-row>
      <v-row v-else class="fill-height justify-center ma-0">
        <v-col class="col-12 col-md-11">
          <v-container grid-list-lg class="pa-0">
            <v-row justify="space-between" v-if="isChiefTherapist">
              <v-col class="col-12 col-md-6 col-xl-5">
                <h2>Consultas como Psicólogo</h2>
                <div
                  v-for="(item, index) in consultation"
                  :key="index"
                  class="d-flex flex-column align-start justify-space-between"
                  style="cursor: pointer"
                  @click="goToDetalheConsulta(item)"
                >
                  <div
                    class="
                      yellow
                      d-flex
                      flex-row
                      align-center
                      justify-space-between
                      px-3
                      py-2
                      mt-2
                      w-100
                    "
                  >
                    <p class="ma-0" v-if="item.patient != null">
                      {{ item.patient.name }}
                    </p>
                    <p class="ma-0" v-if="item.patient_psychologist != null">
                      {{ item.patient_psychologist.name }}
                    </p>
                    <div class="d-flex flex-row align-center justify-center">
                      <span class="date ma-2 align-end d-flex">
                        <v-icon color="primary">date_range</v-icon>
                        <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                      </span>
                      <span class="time ma-2 align-end d-flex">
                        <v-icon color="primary">access_time</v-icon>
                        <p class="mb-0 ml-2">
                          {{ item.time | formatDateTZ(item.date, item.time) }}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col class="col-12 col-md-6 col-xl-5">
                <h2>Consultas como terapeuta</h2>
                <div
                  v-for="(item, index) in therapistConsultation"
                  :key="index"
                  class="d-flex flex-column align-start justify-space-between"
                  style="cursor: pointer"
                  @click="goToDetalheConsulta(item)"
                >
                  <div
                    class="
                      yellow
                      d-flex
                      flex-row
                      align-center
                      justify-space-between
                      px-3
                      py-2
                      mt-2
                      w-100
                    "
                  >
                    <p class="ma-0 gray--text text-body-2" v-if="item.patient">
                      {{ item.patient.name }}
                    </p>
                    <p
                      class="ma-0 gray--text text-body-2"
                      v-if="item.patient_psychologist"
                    >
                      {{ item.patient_psychologist.name }}
                    </p>

                    <div class="d-flex flex-row align-center justify-center">
                      <span class="date ma-2 align-end d-flex">
                        <v-icon color="primary">date_range</v-icon>
                        <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                      </span>
                      <span class="time ma-2 align-end d-flex">
                        <v-icon color="primary">access_time</v-icon>
                        <p class="mb-0 ml-2">
                          {{ item.time | formatDateTZ(item.date, item.time) }}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>

            <div v-if="!isChiefTherapist" class="grid-section">
              <v-row style="width: 100%">
                <div style="width: 100%">
                  <h2 class="next-query">Próximas Consultas</h2>
                  <div v-if="lookmore == false" class="card-pisc-container">
                    <v-row v-for="(item, index) in consultation" :key="index">
                      <div style="width: 100%">
                        <div v-if="index >= 5"></div>
                        <div v-else class="card-pisc">
                          <div
                            class="text-decoration-none my-list"
                            style="cursor: pointer"
                            @click="goToDetalheConsulta(item)"
                          >
                            <p class="ma-0" v-if="item.patient != null">
                              {{ item.patient.name }}
                            </p>
                            <p
                              class="ma-0"
                              v-if="item.patient_psychologist != null"
                            >
                              {{ item.patient_psychologist.name }}
                            </p>
                            <span class="date ma-2 align-end d-flex">
                              <v-icon color="primary">date_range</v-icon>
                              <p class="mb-0 ml-2">
                                {{ moment(item.date).format('DD/MM') }}
                              </p>
                            </span>
                            <span class="time ma-2 align-end d-flex">
                              <v-icon color="primary">access_time</v-icon>
                              <p class="mb-0 ml-2">
                                {{
                                  item.time | formatDateTZ(item.date, item.time)
                                }}
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-row>
                    <footer v-if="consultation.length > 5" class="lookmore">
                      <v-btn color="primary" v-on:click="setLookOpen"
                        >Ver mais</v-btn
                      >
                    </footer>
                  </div>
                  <div v-else class="card-pisc-container">
                    <v-row v-for="(item, index) in consultation" :key="index">
                      <div style="width: 100%">
                        <div class="card-pisc">
                          <div
                            class="text-decoration-none my-list"
                            style="cursor: pointer"
                            @click="goToDetalheConsulta(item)"
                          >
                            <p class="ma-0" v-if="item.patient != null">
                              {{ item.patient.name }}
                            </p>
                            <p
                              class="ma-0"
                              v-if="item.patient_psychologist != null"
                            >
                              {{ item.patient_psychologist.name }}
                            </p>
                            <span class="date ma-2 align-end d-flex">
                              <v-icon color="primary">date_range</v-icon>
                              <p class="mb-0 ml-2">
                                {{ moment(item.date).format('DD/MM') }}
                              </p>
                            </span>
                            <span class="time ma-2 align-end d-flex">
                              <v-icon color="primary">access_time</v-icon>
                              <p class="mb-0 ml-2">
                                {{
                                  item.time | formatDateTZ(item.date, item.time)
                                }}
                              </p>
                            </span>
                          </div>
                        </div>
                      </div>
                    </v-row>
                    <footer class="lookmore">
                      <v-btn color="primary" v-on:click="setLookClose"
                        >Ver menos</v-btn
                      >
                    </footer>
                  </div>
                </div>
                <!-- <v-col
                  class="col-12 col-md-6"
                  v-if="!firstAppointments && !isChiefTherapist && !isAproved"
                >
                  <div
                    class="
                      caixa-primeira-consulta
                      ml-md-auto
                      pa-3
                      d-flex
                      flex-column
                      align-center
                      justify-space-between
                    "
                  >
                    <div class="d-flex flex-row align-center justify-center">
                      <v-icon size="50" class="primary--text mr-2">
                        hearing
                      </v-icon>
                      <p class="ma-0 lato-bold gray--text f-10">
                        Agende com o terapeuta chefe e garanta a análise do seu
                        perfil.
                        <strong
                          >Se está aqui pela primeira vez, é importante agendar
                          com o terapeuta-chefe antes de se tornar um dos
                          nossos! Este primeiro encontro não tem custo para o
                          Psicólogo.</strong
                        >
                      </p>
                    </div>
                    <v-btn
                      :to="chief_therapist_route"
                      class="mt-3 px-5 rounded-lg f-1"
                      color="secondary"
                    >
                      AGENDAR
                    </v-btn>
                  </div>
                </v-col> -->
              </v-row>
              <div v-if="firstAppointments || isChiefTherapist">
                <h2 class="text-left">Consultas como Terapeuta Chefe</h2>
                <div
                  v-for="(item, index) in firstAppointments"
                  :key="index"
                  class="d-flex flex-column align-start justify-space-between"
                >
                  <router-link
                    v-if="item.status === 'SCHEDULED'"
                    :to="{ name: 'ConsultaTerapeuta', params: { id: item.id } }"
                    class="text-decoration-none"
                  >
                    <div
                      class="
                        yellow
                        d-flex
                        flex-row
                        align-center
                        justify-center
                        px-3
                        py-2
                        mt-2
                        box-consulta-terapeuta
                      "
                    >
                      <p class="ma-0 gray--text text-body-2">
                        {{ item.psychologist_name }}
                      </p>
                      <span class="date ma-2 align-end d-flex">
                        <v-icon color="primary">date_range</v-icon>
                        <p class="mb-0 ml-2">{{ item.date | formatDate }}</p>
                      </span>
                      <span class="time ma-2 align-end d-flex">
                        <v-icon color="primary">access_time</v-icon>
                        <p class="mb-0 ml-2">
                          {{ item.time | formatDateTZ(item.date, item.time) }}
                        </p>
                      </span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <v-row
              v-if="!isConsultation"
              class="fill-height justify-center mt-5"
            >
              <v-col class="col-10 col-md-6">
                <div class="no-schedule pa-3">
                  <v-icon
                    x-large
                    color="gray"
                    style="font-size: 80px; padding-bottom: 10px"
                    >sentiment_very_dissatisfied</v-icon
                  >
                  <p
                    class="subtitle-1"
                    style="color: #6f6f6f; font-weight: bold"
                  >
                    Você não tem compromissos futuros.
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <v-col class="col-12 col-md-11">
          <div class="mt-4">
            <v-container grid-list-lg class="pa-0">
              <v-row class="justify-center justify-md-space-between">
                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Agenda"
                    iconName="event"
                    :info="qtd_consultation_now"
                    link="Schedule"
                    colorIcon="primary"
                  />
                </v-col>

                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Pacientes"
                    imgName="speaking_90x90_red"
                    :info="total_patients"
                    link="historico-pacientes"
                    colorIcon="primary"
                  />
                </v-col>

                <!-- <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Receita"
                    iconName="bar_chart"
                    info="Ver Extrato"
                    link="financeiro"
                    colorIcon="primary"
                  />
                </v-col>-->

                <v-col class="col-10 col-sm-6 col-md-3 col-lg-3">
                  <CardInfo
                    sessionName="Avaliação"
                    iconName="star"
                    :info="average_rating"
                    colorIcon="#ED8A19"
                  />
                </v-col>
              </v-row>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-footer class="pa-0">
      <v-row class="justify-center ma-0">
        <v-col
          class="
            primary
            py-3
            text-center
            white--text
            col-12
            d-flex
            justify-space-around
            align-center
            footer
          "
          style="font-size: 12px"
        >
          <div></div>
          <div class="description">
            <strong>RESPONSÁVEL TÉCNICO</strong> Inês Mata CRP/03: 9904. OPP: CP
            23204
          </div>
          <v-btn to="/psicologo/faq" class="btn-faq">Faq</v-btn>
        </v-col>
      </v-row>
    </v-footer>
    <PopUp ref="popUp" :cardItem="cardItem" @ok="onInput" />

    <v-dialog
      v-model="no_digital_account"
      class="dialog-digital-account"
      persistent
      max-width="400"
    >
      <v-card class="dialog-digital-account">
        <h1>Dados Bancários</h1>
        <section>
          <div>
            <span
              >Você não possui conta bancária cadastrada, é necessário cadastrar
              para poder disponibilizar agenda.</span
            >
          </div>
        </section>
        <footer>
          <button @click="onClose()">Cancelar</button>
          <button @click="gotToDigitalAccount()">Cadastrar conta</button>
        </footer>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import moment from 'moment';
import CardInfo from '../../components/CardInfo';
import PopUp from '../../components/PupUP.vue';
import DialogHelpCenter from '@/components/DialogHelpCenter.vue';

import {
  getConsultationsNow,
  totalPatients,
  average,
  getConsultations,
  getProfile,
} from '../../services/psychologists';

import generalService from '../../services/general';
import api from '../../services/httpClient';
import getLanguage from '../../utils/getLanguage';

export default {
  components: {
    CardInfo,
    PopUp,
    DialogHelpCenter,
  },

  data: () => ({
    chief_therapist_route: '',
    cod: '',
    qtd_consultation_now: '-',
    total_patients: 0,
    average_rating: '0/5',
    isLoading: false,
    isConsultation: Boolean,
    firstAppointments: false,
    isChiefTherapist: false,
    isAproved: false,
    consultation: [],
    therapistConsultation: [],
    lookmore: false,
    cardItem: [],
    no_digital_account: false,
  }),

  async created() {
    this.isLoading = true;
    await this.getCod();
    await this.getProfileSpecs();
    await this.getConsultations();
    await this.getConsultationsNow();
    await this.getTotalPatients();
    await this.verifyTherapistAppointments(this.cod);
    this.getAverage();
    this.isLoading = false;
    const language = getLanguage(window.location.href);
    if (language === 'pt-BR') {
      this.chief_therapist_route = `/psicologo/profile-terapeuta/${process.env.VUE_APP_CHIEF_THERAPIST_BR}`;
    } else {
      this.chief_therapist_route = `/psicologo/profile-terapeuta/${process.env.VUE_APP_CHIEF_THERAPIST_PT}`;
    }
  },
  mounted() {
    this.popUp();
  },
  methods: {
    popUp() {
      api
        .get('/popups/')
        .then((res) => {
          const { data } = res;
          this.cardItem = data;
          if (this.cardItem.length === 0 || this.cardItem[0].active === false) {
            return;
          }
          const { popUp } = this.$refs;
          if (!popUp) return;
          popUp.openDialog();
        })
        .catch((err) => console.log(err));
    },
    async getProfileSpecs() {
      const res = await getProfile(this.cod);
      if (res.is_active) {
        this.no_digital_account = res.digital_account ? false : true;
      }
      this.isChiefTherapist = res.is_chief_therapist;
      this.isAproved = res.is_active;
    },
    async verifyTherapistAppointments() {
      const res = await generalService.getFirstAppointments();
      if (res.data === '') {
        this.firstAppointments = null;
      } else {
        this.firstAppointments = res.data;
      }
    },
    async getCod() {
      this.cod = localStorage.getItem('user-id');
    },
    setLookClose() {
      this.lookmore = false;
    },
    setLookOpen() {
      this.lookmore = true;
    },
    async getConsultations() {
      try {
        const date = moment().format('YYYY-MM-DD 00:00');
        const data = await getConsultations(this.cod, date, 9);
        if (data.length !== 0) {
          if (this.isChiefTherapist) {
            // eslint-disable-next-line no-restricted-syntax
            for (const appointment of data) {
              if (appointment.with_chief_therapist) {
                this.therapistConsultation.push(appointment);
              } else {
                this.consultation.push(appointment);
              }
            }
          } else {
            this.consultation = data;
          }
          this.isConsultation = true;
        } else {
          this.isConsultation = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        console.log(this.isAproved);
      }
    },
    goToDetalheConsulta(consulta) {
      // Se não tiver paciente é porque é uma consulta de psicólogo com terapeuta
      if (consulta.patient == null) {
        this.$router.push({
          name: 'ConsultaTerapeuta',
          params: { id: consulta.id },
        });
      } else {
        // Se tiver paciente é porque é uma consulta normal (paciente com psicólogo)
        this.$router.push({
          name: 'DetalheConsulta',
          params: { id: consulta.id },
        });
      }
    },
    /**
     * Pega as consultas do dia atual e devolve a quantidade.
     */
    async getConsultationsNow() {
      try {
        const { data } = await getConsultationsNow(
          this.cod,
          new Date().toISOString().substr(0, 10),
        );
        const { length } = data;
        this.qtd_consultation_now = `${length} consultas hoje`;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Pega o total de paciente de um psicologo.
     */
    async getTotalPatients() {
      try {
        this.total_patients = await totalPatients(this.cod);
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Pega a classificação média do psicologo.
     */
    async getAverage() {
      try {
        const { average_rating } = await average(this.cod);
        this.average_rating = `${average_rating}/5`;
      } catch (error) {
        console.log(error);
      }
    },
    gotToDigitalAccount() {
      this.$router.replace('/psicologo/cadastro-bancario');
    },
    onClose() {
      this.no_digital_account = false;
    },
    moment,
  },
};
</script>

<style lang="scss" scoped>
h2 {
  color: var(--v-primary-base);
}

.block-search {
  background-image: url('../../assets/bg_dashboard.png');
  height: 360px;
  display: block;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.my-list {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 0;

  p {
    flex: 1;
  }
}

.grid-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  padding: 14px 6px;
}
.grid-section h2 {
  margin-bottom: 13px;
}

.card-pisc-container {
  display: flex;
  flex-direction: column;
}

.card-pisc-container > div {
  width: 100%;
  margin: 4px 0px;
  border-radius: 5px;
}

.card-pisc {
  width: 100%;
  background: #fffde3;
  padding: 8px 12px;
}

.no-schedule {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background: #02a55333;
  border-radius: 20px;
  border: 1px dashed #02a554;
}

.lookmore {
  widows: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.lookmore button {
  background: 02a554;
}

.caixa-primeira-consulta {
  border: 1px solid #93291e;
  background-color: #93291e0f;
  border-style: dashed;
  border-radius: 15px;
  width: 400px;
}

.box-consulta-terapeuta {
  width: 430px;
}

.dialog-digital-account {
  padding: 40px 20px;
  background: #ededed;
}
.dialog-digital-account section {
  text-align: center;
}
.dialog-digital-account footer {
  margin-top: 35px;
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.dialog-digital-account button {
  width: 150px;
  padding: 4px 8px;
  border-radius: 5px;
  font-weight: 600;
  font-size: 16px;
}

.dialog-digital-account button:first-child {
  background: transparent;
  color: #635e5e;
  border: 2px solid #635e5e;
}
.dialog-digital-account button:last-child {
  background: #45a655;
  color: #fff;
}
.dialog-digital-account h1 {
  color: #45a655;
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
}
@media screen and (max-width: 420px) {
  .caixa-primeira-consulta {
    width: 100%;
  }
  .box-consulta-terapeuta {
    width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .grid-section {
    display: flex;
    flex-direction: column;
  }
  .next-query {
    padding-left: 10px;
  }
  .footer {
    display: flex;
    flex-direction: column;
  }
  .description {
    max-width: 220px;
  }
}
.btn-faq {
  width: 110px;
  height: 35px;
  color: #93291e;
}
</style>
